const disabledCourse = (courseName) => {
    return {
        title: {
            text: `The Growth Over Time chart is unavailable for the course ${courseName}.`,
            floating: true,
            verticalAlign: 'middle',
        },
    };
};

export default disabledCourse;
